// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import './theme/element/index.css'  //自定义主题样式文件
import './assets/css/common.css'  //单独引入通用样式文件
import cookie from "./service/cookie";
import config from '../static/config.json';
Vue.use(Element)

Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.$http = axios
// 引入自定义过滤器
import tableFilters from './commonJs/Filters'
// 这种方式可以将filters.js中的所有过滤器都注册
for (let key in tableFilters) {
  Vue.filter(key, tableFilters[key])
}

// 引入重新定义的$message
import {message} from './commonJs/ResetMessage'
Vue.prototype.$message = message;

// 使用vue-cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);


const VUE_APP_VERSION = 'v2.7.2';
const vers = localStorage.getItem('WFVersion');

// 版本不一致的话删除登录信息 重新登录
if(VUE_APP_VERSION != vers){
  localStorage.clear();
  cookie.removeCookie('access_token_ul_wf');//token authorization
  cookie.removeCookie('refresh_key_ul_wf');//用来刷新authorization
  window.localStorage.setItem('WFVersion',VUE_APP_VERSION);
  location.href='/login';
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js